import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { getQuery } from "../ServiceController";

const ComunicazioniFSE = ({ soloImportanti = false, cardAttiva = true }) => {
  const dispatch = useDispatch();

  const [newUserList, setNewUserList] = useState([]);
  const [isNewUserListLoading, setIsNewUserListLoading] = useState(false);

  useEffect(() => {
    const fetchNewUserList = async () => {
      try {
        setIsNewUserListLoading(true);
        const response = await dispatch(
          getQuery("Comunicazioni/ElencoComunicazioniAttive")
        );

        const filtrati = soloImportanti
          ? (response || []).filter(item => item.importante === true)
          : response;

        setNewUserList(filtrati || []);
      } catch (error) {
        console.error(error);
      } finally {
        setIsNewUserListLoading(false);
      }
    };

    fetchNewUserList();
  }, [dispatch, soloImportanti]);

  if (!isNewUserListLoading && newUserList.length === 0) return null;

  return (
    <div className="row">
      <div className="col-12">
        <div className={`${cardAttiva ? "card" : ""} m-1`}>
          <div className="card-title card-body mb-0 pb-0">
            <h3 className="mb-4">Le news di referto FSE</h3>
          </div>

          <div className="table-responsive">
            {isNewUserListLoading ? (
              <div className="p-3">Caricamento...</div>
            ) : (
              <table id="user_table" className="table">
                <thead>
                  <tr>
                    <th scope="col">#</th>
                    <th scope="col" style={{ textAlign: "left" }}>Titolo</th>
                    <th scope="col" style={{ textAlign: "left" }}>Messaggio</th>
                  </tr>
                </thead>
                <tbody>
                  {newUserList.map((item, index) => (
                    <tr key={item.idComunicazione}>
                      <th scope="row">{index + 1}</th>
                      <td
                        style={{
                          fontSize: "0.85rem",
                          fontWeight: "bold",
                          textAlign: "left",
                        }}
                      >
                        {item.titolo}
                      </td>
                      <td
                        style={{ textAlign: "left" }}
                        dangerouslySetInnerHTML={{ __html: item.messaggio }}
                      />
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ComunicazioniFSE;
